import React from 'react'
import { Box, Heading } from 'react-bulma-components'
import History, { HistoryItem, HistoryLocales } from '../history/history'

export interface MissionHistoryPanelProps {
  items: HistoryItem[]
  locales: HistoryLocales
}

/**
 * History tab: sorted mission change log.
 */
const MissionHistoryPanel: React.FC<MissionHistoryPanelProps> = ({ items, locales }) => {
  return (
    <Box>
      <History items={items} locales={locales} />
    </Box>
  )
}

export default MissionHistoryPanel
